"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addHotjarSuppress = exports.validatedSessionStorage = exports.getQueueStatus = exports.getIsChatOpen = exports.setOpenChatOverrideFunc = void 0;
var constants_1 = require("./constants");
var date_fns_tz_1 = require("date-fns-tz");
var openChatOverride = null;
var setOpenChatOverrideFunc = function (override) {
    openChatOverride = override;
};
exports.setOpenChatOverrideFunc = setOpenChatOverrideFunc;
var getIsChatOpen = function () {
    if (openChatOverride) {
        return openChatOverride();
    }
    var today = (0, date_fns_tz_1.utcToZonedTime)(new Date(), 'Europe/Copenhagen');
    var currentDayOfWeek = (0, date_fns_tz_1.format)(today, 'EEEE');
    var currentTime = (0, date_fns_tz_1.format)(today, 'kk:mm');
    // weekend rule
    if (currentDayOfWeek === 'Saturday' || currentDayOfWeek === 'Sunday')
        return false;
    // friday rule
    if (currentDayOfWeek === 'Friday' &&
        currentTime >= constants_1.openingHours.fridayStart &&
        currentTime < constants_1.openingHours.fridayEnd) {
        return true;
    }
    // rest of the week rule
    return (currentDayOfWeek !== 'Friday' &&
        currentTime >= constants_1.openingHours.mondayToThursdayStart &&
        currentTime < constants_1.openingHours.mondayToThursdayEnd);
};
exports.getIsChatOpen = getIsChatOpen;
var getQueueStatus = function (queueInfo) {
    var estimatedWaitTimeSeconds = Number(queueInfo.estimatedWaitTimeInSeconds);
    if (queueInfo.status === 'Closed') {
        return 'closed';
    }
    switch (true) {
        case estimatedWaitTimeSeconds < 31:
            return 'not-busy';
        case estimatedWaitTimeSeconds < 121:
            return 'little-busy';
        case estimatedWaitTimeSeconds < 301:
            return 'kinda-busy';
        case estimatedWaitTimeSeconds < 421:
            return 'busy';
        case estimatedWaitTimeSeconds < 601:
            return 'very-busy';
        default:
            return 'extremely-busy';
    }
};
exports.getQueueStatus = getQueueStatus;
var validatedSessionStorage = function () {
    try {
        sessionStorage.setItem('test', 'test');
        sessionStorage.removeItem('test');
        return sessionStorage;
    }
    catch (e) {
        return null;
    }
};
exports.validatedSessionStorage = validatedSessionStorage;
var addHotjarSuppress = function () {
    var _a, _b;
    (_b = (_a = document === null || document === void 0 ? void 0 : document.querySelector('.genesys-app')) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.add('data-hj-suppress');
};
exports.addHotjarSuppress = addHotjarSuppress;
//# sourceMappingURL=utils.js.map